import { Address } from "@/services/backend/addresses/types/address";

function formatAddressQuery(address: Address): string {
  const parts: string[] = [];
  if (address.street.trim() !== "") {
    parts.push(address.street.trim());
  }
  const cityLine = [address.postalCode, address.city]
    .map((p) => p.trim())
    .filter((p) => p !== "")
    .join(" ");
  if (cityLine !== "") {
    parts.push(cityLine);
  }
  if (address.country.trim() !== "") {
    parts.push(address.country.trim());
  }
  return parts.join(", ");
}

export function googleMapsSearchUrl(address: Address): string {
  const query = encodeURIComponent(formatAddressQuery(address));
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
}
